module.exports = __webpack_public_path__ + "static/img/icon.76997b69.png";